import { custom } from "./utilities";
import {
  centerConstants,
  viewPathConstants,
  loginConstants,
  globalSystemConstants,
} from "../../constants";
import { ToastifyService, centerService } from "../../services";

const { CENTER_FORM_STATE } = centerConstants;

const setFormState = (data) => {
  return (dispatch) => {
    dispatch(custom(data, CENTER_FORM_STATE));
  };
};

const registerCenter = (data, navigate,handleShowRegSuccessModal) => {
  return (dispatch) => {
    dispatch(
      custom(loginConstants.LOGIN, globalSystemConstants.SPINNER_ACTIVATE)
    );

    centerService
      .registerCenter(data)
      .then(() => {
        dispatch(setFormState(null));
        if(handleShowRegSuccessModal){
          handleShowRegSuccessModal();
        }
        else{
          navigate(viewPathConstants.REGISTRATION_SUCCESS);
        }
      })
      .catch((error) => {
        ToastifyService.showError(error);
      })
      .finally(() => {
        dispatch(
          custom(loginConstants.LOGIN, globalSystemConstants.SPINNER_DEACTIVATE)
        );
      });
  };
};

export const centerActions = {
  setFormState,
  registerCenter,
};
